const NOINDEX_CONTENT = "noindex, nofollow, noarchive";
const ROBOTS_META_NAMES = ["robots", "googlebot"] as const;

/**
 * REACT_APP_NO_INDEX=true → block indexing.
 * Unset or false → do not add noindex tags.
 */
export const shouldNoIndex = (): boolean => {
  return String(process.env.REACT_APP_NO_INDEX ?? "").toLowerCase() === "true";
};

const upsertMeta = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const removeMeta = (name: string) => {
  document.querySelector(`meta[name="${name}"]`)?.remove();
};

export const applyRobotsMeta = () => {
  if (shouldNoIndex()) {
    ROBOTS_META_NAMES.forEach((name) => upsertMeta(name, NOINDEX_CONTENT));
    return;
  }

  ROBOTS_META_NAMES.forEach(removeMeta);
};
